module.exports = __webpack_public_path__ + "static/img/img_btn.29b06f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new/img_btn.png
// module id = w2Gf
// module chunks = 1